var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "action-list" }, [
    _c(
      "li",
      [
        _c(
          "v-dropdown",
          { attrs: { "show-arrow": false } },
          [
            _c(
              "a",
              {
                staticClass: "avatar",
                attrs: {
                  slot: "activator",
                  href: "#",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                },
                slot: "activator",
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-bell" })]
                ),
                _vm._v(" "),
                _vm.activeNotifications && _vm.activeNotifications.length
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-danger",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v(_vm._s(_vm.activeNotifications.length))]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("v-dropdown-item", [
              _c("span", { staticClass: "small_title" }, [
                _vm._v("Уведомления"),
              ]),
            ]),
            _vm._v(" "),
            _vm.activeNotifications && _vm.activeNotifications.length
              ? _vm._l(
                  _vm.getActiveNotifications(),
                  function (notification, i) {
                    return _c(
                      "v-dropdown-item",
                      { key: i },
                      [
                        +notification.type_id === _vm.types.moderateReadyInvoice
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return (() =>
                                        _vm.openInvoice(
                                          notification.sub_object_id
                                        )).apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-file-text-o",
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(notification.sub_object_id) +
                                      " накладная на модерацию\n            "
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return (() =>
                                        _vm.orderToEdit(
                                          notification.object_id
                                        )).apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-phone",
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(notification.object_id) +
                                      " " +
                                      _vm._s(notification.message) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    )
                  }
                )
              : [
                  _c("v-dropdown-item", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return (() => {}).apply(null, arguments)
                          },
                        },
                      },
                      [_c("span", [_vm._v("Нет активных уведомлений")])]
                    ),
                  ]),
                ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }